import { render, staticRenderFns } from "./newAdvertisccc.vue?vue&type=template&id=48715e12&scoped=true&"
import script from "./newAdvertisccc.vue?vue&type=script&lang=js&"
export * from "./newAdvertisccc.vue?vue&type=script&lang=js&"
import style0 from "./newAdvertisccc.vue?vue&type=style&index=0&id=48715e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48715e12",
  null
  
)

export default component.exports